import { useEffect } from "react";
import Profile from "./Profile";

const MyProfile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "MyProfile | Atrable";

  //if didn't made a channel (same thing in youtube) --> redirect to make a channel
  return (
    <>
    </>
  );
};

export default MyProfile;
